"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var awsui_button_1 = require("../button/awsui-button");
var awsui_base_input_1 = require("../input/awsui-base-input");
var CalendarWrapper = /** @class */ (function (_super) {
    __extends(CalendarWrapper, _super);
    function CalendarWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalendarWrapper.prototype.findHeader = function () {
        return this.find('.awsui-calendar__header');
    };
    CalendarWrapper.prototype.findPreviousMonthButton = function () {
        return this.findComponent('.awsui-calendar__button--previous', awsui_button_1.default);
    };
    CalendarWrapper.prototype.findNextMonthButton = function () {
        return this.findComponent('.awsui-calendar__button--next', awsui_button_1.default);
    };
    /**
     * Returns a day container on the calendar.
     *
     * @param row 1-based row index of the day.
     * @param column 1-based column index of the day.
     */
    CalendarWrapper.prototype.findDateAt = function (row, column) {
        return this.find(".awsui-calendar__week:nth-child(" + row + ") .awsui-calendar__date:nth-child(" + column + ")");
    };
    CalendarWrapper.prototype.findSelectedDate = function () {
        return this.find('.awsui-calendar__date--selected');
    };
    return CalendarWrapper;
}(dom_1.ElementWrapper));
var DatePickerWrapper = /** @class */ (function (_super) {
    __extends(DatePickerWrapper, _super);
    function DatePickerWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DatePickerWrapper.prototype.findCalendarDropdown = function () {
        return this.find('.awsui-input-dropdown__dropdown');
    };
    DatePickerWrapper.prototype.findCalendar = function () {
        var calendarElement = this.find('.awsui-calendar');
        return calendarElement ? new CalendarWrapper(calendarElement.getElement()) : null;
    };
    return DatePickerWrapper;
}(awsui_base_input_1.default));
exports.default = DatePickerWrapper;
//# sourceMappingURL=awsui-date-picker.js.map